<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'crop-tracker-list'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
    v-if="loaded"
    ref="transactionList"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "../../../templates/transaction-list";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { mapGetters } from "vuex";
export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  created() {
    this.loaded = true;
  },
  computed: {
    ...mapGetters("notification", ["notificationId", "getNotificationPayload"]),
    setScreenConfig() {
      return {
        title: "Crop Tracker",
        ScreenName: "Crop Tracker - All",
        selectedIndex: 0,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoCropTrackerRunList",
              // items: [],
              // serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Crop Tracker Found",
                message: "Get Started, Add New Crop Tracker",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/crop-tracker/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "CropTracker",
                  "create"
                ),
                // disabled: true,
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              filterIndex: 0,
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "desc",
              width: ColumnWidth.RUNNumber.width,
              forceWidth: true,
              dataField: "MRPRun",
              type: "Integer",
              label: "Run",
              filterLabel: "Run",
              filterDataField: "MRPRun",
            },
            {
              screenField: "MRPName",
              minWidth: ColumnWidth.Name.minWidth,
              filterIndex: 1,
              type: "Text",
            },
            {
              screenField: "AlmondcoMRPSeasonYear",
              dataField: "SeasonYear",
              label: "Season",
              width: ColumnWidth.SeasonYear.width,
              minWidth: ColumnWidth.SeasonYear.minWidth,
              filterIndex: 3,
            },

            {
              screenField: "Narration",
              filterIndex: 2,
              type: "Text",
              textOperators: true,
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
              allowHiding: false,
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterIndex: 4,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "AlmondcoMRPCreatedBy",
              filterIndex: 5,
              width: ColumnWidth.CreatedBy.width,
              minWidth: ColumnWidth.CreatedBy.minWidth,
            },
            {
              cellTemplate: "Status",
              dataField: "Status",
              width: ColumnWidth.Status.width,
              minWidth: ColumnWidth.Status.minWidth,
              customBackGroundColor: (data) => {
                if (data) {
                  if (data.Status === "Generated") return "#4caf50";
                  else if (data.Status === "Generating...") return "#ff9800";
                  else if (data.Status === "Failed") return "#f44336";
                  return undefined;
                } else return undefined;
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        (e.data.Status === "Generated" || e.data.Status === "Failed")
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "crop-tracker",
          mode: "review",
          idProperty: "MRPRun",
        });
      }
    },

    refreshGridData() {
      if (
        this.$refs.transactionList &&
        this.$refs.transactionList.$refs.transactionListGrid
      ) {
        const gridInstance =
          this.$refs.transactionList.$refs.transactionListGrid;
        gridInstance.gridRefresh();
      }
    },
  },

  watch: {
    notificationId() {
      if (
        this.getNotificationPayload &&
        this.getNotificationPayload.messageType ===
          "AlmondcoCropTrackerRunCompleted"
      ) {
        this.refreshGridData();
      }
    },
  },
};
</script>
